import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { MainNavButton } from '../nav-button';

const COPY = defineMessages({
  EXPLORE: {
    id: 'Explore.explore',
    defaultMessage: 'Explore',
    description: '[Type: Label][Vis.: low] - Explore link in main navigation',
  },
});

const Explore = () => <MainNavButton href="/apps/" label={t(COPY.EXPLORE)} />;

export default Explore;
export { Explore };
